import { useState } from "react"
import TrackableEntryInput from "./TrackableEntryInput"

interface CategorySectionProps {
  category: "body" | "work" | "reflection" | "relationship" | "business"
  trackables: any[]
  entries: Record<string, any>
  onEntryChange: (trackableId: string, value: any) => void
}

export default function CategorySection({ category, trackables, entries, onEntryChange }: CategorySectionProps) {
  const [isExpanded, setIsExpanded] = useState(true)

  const getCategoryColor = () => {
    switch (category) {
      case "body":
        return "border-l-4 border-teal-500 bg-teal-50"
      case "work":
        return "border-l-4 border-yellow-500 bg-yellow-50"
      case "reflection":
        return "border-l-4 border-purple-500 bg-purple-50"
      case "relationship":
        return "border-l-4 border-pink-500 bg-pink-50"
      case "business":
        return "border-l-4 border-cyan-500 bg-cyan-50"
      default:
        return "border-l-4 border-gray-500 bg-gray-50"
    }
  }

  const getCategoryEmoji = () => {
    switch (category) {
      case "body":
        return "💪"
      case "work":
        return "💼"
      case "reflection":
        return "🧠"
      case "relationship":
        return "❤️"
      case "business":
        return "📈"
      default:
        return "📌"
    }
  }

  if (trackables.length === 0) return null

  return (
    <div className={`border-2 border-border ${getCategoryColor()}`}>
      {/* Category Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 flex items-center justify-between hover:bg-background/50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <span className="text-2xl">{getCategoryEmoji()}</span>
          <span className="font-bold capitalize text-lg">{category}</span>
          <span className="text-sm text-muted-foreground">({trackables.length})</span>
        </div>
        <span className="text-xl">{isExpanded ? "▼" : "▶"}</span>
      </button>

      {/* Trackables List */}
      {isExpanded && (
        <div className="border-t-2 border-border bg-background p-4 space-y-4">
          {trackables.map((trackable) => (
            <div key={trackable.id} className="space-y-2">
              <label className="block text-sm font-semibold">{trackable.promptText}</label>
              <TrackableEntryInput
                trackable={trackable}
                value={entries[trackable.id]}
                onChange={(value) => onEntryChange(trackable.id, value)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
